export default "__VITE_ASSET__CbsOZGq3__"